export default __webpack_public_path__ + "static/media/logo-mono-on-black.ad0b4923.svg";